/**
 * Recently Viewed Products - localStorage-based tracking + rendering
 * Tracks product visits, renders horizontal scrollable row
 */
(function () {
  "use strict";

  var STORAGE_KEY = "lithofin_rv";
  var MAX_ITEMS = 8;

  function getViewed() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveViewed(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { /* quota */ }
  }

  // Track current product (if on a product page)
  var dataEl = document.querySelector("[data-rv-product]");
  if (dataEl) {
    try {
      var p = JSON.parse(dataEl.textContent);
      var viewed = getViewed();
      viewed = viewed.filter(function (v) { return v.id !== p.id; });
      viewed.unshift(p);
      if (viewed.length > MAX_ITEMS) viewed = viewed.slice(0, MAX_ITEMS);
      saveViewed(viewed);
    } catch (e) { /* ignore parse errors */ }
  }

  // Render recently viewed sections
  var containers = document.querySelectorAll(".rv-container");
  if (!containers.length) return;

  var viewed = getViewed();
  var currentId = dataEl ? (function () { try { return JSON.parse(dataEl.textContent).id; } catch (e) { return null; } })() : null;
  viewed = viewed.filter(function (v) { return v.id !== currentId; });

  if (viewed.length < 2) return;

  function esc(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

  containers.forEach(function (container) {
    var label = container.dataset.label || "Recently viewed";
    var html = '<h3 class="rv__title">' + esc(label) + "</h3>";
    html += '<div class="rv__scroll">';
    viewed.forEach(function (v) {
      html += '<a class="rv__card" href="' + esc(v.url) + '">';
      if (v.img) html += '<img class="rv__img" src="' + esc(v.img) + '" alt="" loading="lazy" width="160" height="160">';
      html += '<span class="rv__name">' + esc(v.title) + "</span>";
      if (v.price) html += '<span class="rv__price">' + esc(v.price) + "</span>";
      html += "</a>";
    });
    html += "</div>";
    container.innerHTML = html;
    container.style.display = "block";
  });
})();
